import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  BusinessRelationshipFormType,
  FormErrors,
  getSchema,
} from '../../forms/businessRelationshipForm';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent } from './FormContent';

interface Props {
  initialValues?: BusinessRelationshipFormType;
  onSubmit: (values: BusinessRelationshipFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  clientType?: ClientType;
  subTitle?: string;
}

export const BusinessRelationship = ({
  initialValues,
  canGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onGoBack,
  onSubmit,
  clientType,
  subTitle,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.businessRelationship.subtitle')}
      title={t('onboarding.businessRelationship.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <FormContent />
      </Stack>
    </FormBodyWrapper>
  );
};
